interface Props {
  label?: string;
}

export function LoadingState({ label = 'Loading' }: Props) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full w-full items-center justify-center gap-2 text-[12px] text-zinc-500"
    >
      <span
        aria-hidden="true"
        className="inline-block h-1.5 w-1.5 animate-pulse rounded-full"
        style={{ backgroundColor: 'var(--accent)' }}
      />
      <span>{label}…</span>
    </div>
  );
}
